export const MAX_DAPP_NAME_LENGTH = 25;
export const MAX_SUBTITLE_LENGTH = 50;
export const MAX_EDITORS_CHOICE_HEADLINE_LENGTH = 50;
export const MAX_EDITORS_CHOICE_TAG_LENGTH = 12;
export const MIN_PREVIEW_IMAGES = 4;
export const MAX_PREVIEW_IMAGES = 8;
